package music.jammers.client.shared.event.data.repository

import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import music.jammers.client.shared.event.domain.repository.CardInfoRepository
import music.jammers.shared.event.domain.model.CardInfo

internal class CardInfoRepositoryImpl(
    private val httpClient: HttpClient,
) : CardInfoRepository {

    override suspend fun getAll(): List<CardInfo> =
        httpClient.get("cards").body<List<CardInfo>>()
}